import React, { useCallback } from 'react';

import { getArrFromLocalStorage, setArrToLocalStorage } from '@vlabs/monokit/shared/lib/localStorage';
import { DuplicateIcon } from '@vlabs/icons';
import { routes } from '@vlabs/shared/navigation/routes';
import { Control } from '@vlabs/uikit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import nextId from 'react-id-generator';
import { connect } from 'react-redux';
import { generatePath, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { updateNotification } from '../store';

function DuplicateNotificationCellComponent({ value = {}, onSubmitNotification }) {
  const { t } = useTranslation();
  const history = useHistory();

  const {
    email = { recipients: [] },
    telegram = { recipients: [] },
    filters = {},
  } = value;

  const name = filters.name || '';
  const type = value?.filters?.type?.value;
  const eventType = type ?? 'events';

  const onEventNotification = useCallback(async () => {
    const newData = {
      ...value,
      filters: {
        ...filters,
        name: `copy of ${name}`,
      },
      email: {
        ...email,
        recipients: email.recipients.join(','),
      },
      telegram: {
        ...telegram,
        recipients: telegram.recipients.join(','),
      },
    };
    const data = await onSubmitNotification('create', newData);
    history.push(generatePath(routes.notifications.read, { notificationId: data?.data?.uuid }), { eventType });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onVANotification = () => {
    const newData = {
      ...value,
      filters: {
        ...filters,
        name: `copy of ${name}`,
      },
      uuid: nextId(),
    };
    const vaNotificationArr = getArrFromLocalStorage('VANotificationsArr');
    setArrToLocalStorage('VANotificationsArr', [...vaNotificationArr, newData]);
    toast.success(t('vlNotifier:обновление.успех'));

    const newVANotificationArr = getArrFromLocalStorage('VANotificationsArr');
    const notificationId = newVANotificationArr[newVANotificationArr.length - 1].uuid;

    history.push(generatePath(routes.notifications.read, { notificationId }), { eventType });
  };

  return (
    <Control.IconButton
      data-testid="notificationDuplicateButton"
      icon={<DuplicateIcon />}
      kind="secondary"
      onClick={type === 'videoanalytics' ? onVANotification : onEventNotification}
      variant="flat"
    />
  );
}

export const DuplicateNotificationCell = connect(
  null,
  (dispatch) => ({
    onSubmitNotification: (id, data) => dispatch(updateNotification(id, data)),
  }),
)(DuplicateNotificationCellComponent);

DuplicateNotificationCell.propTypes = {
  value: PropTypes.object,
  onSubmitNotification: PropTypes.func,
};
